import {TranslatableResourceType} from 'types';

import {
  TranslatableResourceTypeMapping,
  MetafieldOwnerTypeMapping,
  TranslatableResourceTypesWithHandleTranslations,
} from './types';
import {translatableResourceTypesWithHandleTranslationsList} from './constants';

const GROUP_KEYS_MAP: TranslatableResourceTypeMapping<string[]> &
  MetafieldOwnerTypeMapping<string[]> = {
  [TranslatableResourceType.ProductOptionValue]: ['name'],
  [TranslatableResourceType.Link]: ['title'],
  'METAFIELD-PRODUCTVARIANT': ['value'],
};

export function isGroupedKey(
  translatableResourceType: TranslatableResourceType,
  key: string,
  ownerType?: string,
) {
  const keyForResource =
    translatableResourceType === TranslatableResourceType.Metafield &&
    ownerType === 'PRODUCTVARIANT'
      ? 'METAFIELD-PRODUCTVARIANT'
      : translatableResourceType;
  return Boolean(GROUP_KEYS_MAP[keyForResource]?.includes(key));
}

// This is temporary until we have localize Theme Sections
// directly in the Theme Editor
// Key could be one of the following format:
// section.product.json.multicolumn.column-1.link_label:19gzze90ptj0y
// section.template--161__multicolumn
// section.announcement-bar
export function getHumanReadableTranslatableThemeKey(key: string) {
  return Array.from(
    new Set(
      key
        .split(':')[0]
        .replace('section.sections/', '')
        .replace('section.', '')
        .replace('template-', '')
        .split('.')
        .slice(-2)
        .filter((part) => part !== 'json')
        .map((part) => {
          let formattedPart = part;
          formattedPart = formattedPart.replace(/-[0-9]+/g, ' ');
          formattedPart = formattedPart.replace(/[_-]/g, ' ');
          formattedPart = formattedPart.replace(/\b([a-z])/gi, (char) =>
            char.toUpperCase(),
          );
          return formattedPart.trim();
        }),
    ),
  ).join(': ');
}

export function isTranslatableResourceWithHandleTranslation(
  translatableResource: TranslatableResourceType,
  key: string,
): translatableResource is TranslatableResourceTypesWithHandleTranslations {
  return (
    translatableResourceTypesWithHandleTranslationsList.includes(
      translatableResource as TranslatableResourceTypesWithHandleTranslations,
    ) && key === 'handle'
  );
}
